/**
 * Shorthand to obj.hasOwnProperty() compatible with "no-prototype-builtins" ESLint rule.
 * @see http://eslint.org/docs/rules/no-prototype-builtins
 *
 * @param {Object} obj
 * @param {String} prop
 * @return {Boolean}
 */
export const hasOwn = (obj, prop) =>
  Object.prototype.hasOwnProperty.call(obj, prop);
